<template>
    <div id="pricing" class="pricing-section text-center">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                <div class="pricing-intro wow fadeInDown">
                    <h1>Blog_</h1>
                    <p>
                    Comming soon
                    </p>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="table-left wow fadeInDown">
                            <div class="pricing-details">
                                <h2>Comming Soon</h2>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="table-right wow fadeInDown">
                            <div class="pricing-details">
                                <h2>Comming Soon</h2>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="table-right wow fadeInDown">
                            <div class="pricing-details">
                                <h2>Comming Soon</h2>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Blog',
}
</script>

<style lang="stylus">
@media only screen and (min-width: 240px)
    .pricing-section 
        width 100%
        height 100%
        padding-top 100px
        padding-bottom 100px
        background #FFFFFF
        .table-center 
            margin-top 0
    .pricing-intro 
        padding-bottom 30px 
        h1 
            font-size 32px
            color #364655
            font-weight 600
            line-height 1.4
            margin-bottom 20px
        p 
            font-size 16px
            color #97a6b5
            font-weight 500
            line-height 1.6
            letter-spacing 0
            margin-top 10px
            margin-bottom 50px
    .pricing-details 
        padding 50px 0 0 0
    .pricing-section .table-left, .pricing-section .table-right 
        padding 20px 20px 50px 20px
        margin 0 auto
        margin-bottom 30px
        background-color #FFFFFF
        box-shadow 0px 0px 60px 0px rgba(0,0,0,.1)
        border transparent
        border-radius 10px
        max-width 400px
        margin-top 20px
    .table-left .icon, .table-right .icon 
        padding 50px 50px 40px 50px
    .table-left .icon img, .table-right .icon img 
        width 60px
        height 60px
        margin 0 auto
    .table-left .pricing-details span, .table-right .pricing-details span 
        display block
        font-family 'Montserrat'
        font-size 32px
        font-weight 600
        color #364655
        opacity 0.7
        margin 20px 0
    .table-left .pricing-details h2, .table-right .pricing-details h2 
        font-size 21px
        font-weight 600
        color #6d48e5
        margin-bottom 30px
    .table-left .pricing-details p, .table-right .pricing-details p 
        font-size 16px
        font-weight 500
        color #364655
        line-height 1.4
    .table-left .pricing-details ul, .table-right .pricing-details ul 
        margin-top 30px
        margin-bottom 50px
        padding 0
    .table-left .pricing-details li, .table-right .pricing-details li 
        font-family 'Montserrat'
        font-size 16px
        font-weight 500
        color #97a6b5
        line-height 1.4
        letter-spacing 0
        margin-bottom 10px
    .pricing-section .table-left:hover, .pricing-section .table-right:hover 
        box-shadow 0 0 80px 0 rgba(0, 0, 0, 0.1)
        -webkit-transition 0.3s
        -moz-transition 0.3s
        -o-transition 0.3s
        transition 0.3s

</style>